<template lang="pug">
  transition
    div(v-if="show" @click.stop="hideModal").wrap-modal-window.f.fh
      div.modal-window-content
        slot
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-modal-window {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  .modal-window-content {
    border-radius: 3px;
  }
}

/* アニメーション中のスタイル */
.v-leave-active, .v-enter-active {
  transition: opacity 0.4s;
}

/* 表示アニメーション */
.v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave {
  opacity: 1;
}
</style>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    hideModal () {
      this.$emit('hideModal')
    }
  }
}
</script>
